var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CompanyCreatedSuccess"},[_c('div',{staticClass:"icons-thumb-up",staticStyle:{"font-size":"90px"}}),_c('h1',{staticClass:"Step Step__title h1 color-secondary"},[_vm._v("\n    "+_vm._s(_vm.compiledText)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }